import React from 'react';
import { Component, Container, ToastNotifications as PuzzleToastNotifications } from 'puzzle';
import _ from 'lodash';
import ToastNotifications from "../Viewport/ToastNotifications/ToastNotifications";

type DRAWER_PROPS = {
  header?: React.ReactNode
  drawerContent: React.ReactNode,
}

type DRAWER_STATE = {}

class Drawer extends Component<DRAWER_PROPS, DRAWER_STATE> {
  public static drawerId: string = 'drawer';

  private onDrawerKeyDown: Function = (e: React.KeyboardEvent) => {
    const { altKey, key, shiftKey } = e;
    let mainGrid = document.getElementById('main-grid');
    const rowId: string = _.get(document.getElementById('drawer'), 'dataset.rowid');

    if (altKey && shiftKey && key === 'D') {
      // Alt+Shift+D will return focus to the row which is connected with drawer
      if (rowId) {
        document.getElementById(rowId)?.focus();
      } else {
        mainGrid?.focus();
      }
    } else if (altKey && shiftKey && key === 'Backspace') {
      // Alt+Shift+Backspace will close drawer
      let closeDrawerBtn = document && document.getElementById('close_drawer');
      closeDrawerBtn?.click();
      if (rowId) {
        // return focus to the row which is connected with drawer
        document.getElementById(rowId)?.focus();
      } else {
        mainGrid?.focus();
      }
    }
  };

  render() {
    const properties: any = {
      ariaLabel: this.translate('description'),
      className: 'tp-drawer',
      htmlTag: 'section',
      id: Drawer.drawerId
    };
    if (this.props.header) {
      _.assign(properties, {
        tabIndex: 0,
        onKeyDown: this.onDrawerKeyDown.bind(this)
      });
    }

    return (
      <aside>
        <Container {...properties}>
          <ToastNotifications moduleId={'ToastNotificationsDrawer'}/>
          <PuzzleToastNotifications
            moduleId={'ToastNotificationsDrawerPuzzle'}
          />
          {this.props.header && <div className={"tp-drawer-header"}>{this.props.header}</div>}
          {this.props.drawerContent}
        </Container>
      </aside>
    );
  }
}

export default Drawer;
